exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pz_modal.schedule-times .modal-header > .fa.fa-times {\n  cursor: pointer;\n}\n.pz_modal.schedule-times .modal-header > .lean-icon.information-fill::before {\n  transform: scale(0.7);\n}\n.pz_modal.schedule-times input {\n  display: inline-block;\n  width: 120px;\n}\n", ""]);

